import { render, staticRenderFns } from "./ApresentacaoGeral.vue?vue&type=template&id=11df157c&scoped=true&"
import script from "./ApresentacaoGeral.vue?vue&type=script&lang=js&"
export * from "./ApresentacaoGeral.vue?vue&type=script&lang=js&"
import style0 from "./ApresentacaoGeral.vue?vue&type=style&index=0&id=11df157c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11df157c",
  null
  
)

export default component.exports